import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=1337d1a8&"
import script from "./chatList.vue?vue&type=script&lang=js&"
export * from "./chatList.vue?vue&type=script&lang=js&"
import style0 from "./chatList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports